<template >
    <div class="container-fluid" v-if="lesson">


       <div class="row">
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h2>{{lesson.name}}</h2>
          </div>
          <div class="card-body">
            <p>{{lesson.description}}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h2>Мэдээлэл</h2>
          </div>
          <div class="card-body">
            <p>Багш: {{lesson.profession}}</p>
            <p>Xичээлийн код: {{lesson.lectureCode}}, {{lesson.id}}</p>
            <p v-if="lesson.semester">Улирал: {{lesson.semester.id}}</p>
            <p v-if="lesson.school">Сургууль: {{lesson.school.id}}</p>
            <p v-if="lesson.department">Xөтөлбөрийн баг: {{lesson.department.id}}</p>
            <p v-if="lesson.program">Хөтөлбөр: {{lesson.program.id}}</p>
          </div>
        </div>
      </div>


    </div>

    <div class="card shadow mb-4" >
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Хичээлийн ирц</h6>
      </div>

      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-sm" id="dataTable" width="100%" cellspacing="0" v-if="students!=null && students.length>0">
            <thead>
              <tr>
                <th>№</th>
                <th>Оюутны нэр, код</th>
                <th v-for="(topic, index) in topics" v-bind:key="topic.id">{{index+1}}. {{topic.name}}</th>

              </tr>
            </thead>

            <tbody>
              <tr v-for="(student, index) in students" v-bind:key="student.id">
                <td>{{index+1}}</td>
                <td><span v-if="student!=null && student.student!=null">{{student.student.name}}-{{student.student.code}}</span></td>
                <td v-for="(st, stindex) in student.attendances" style="cursor:pointer;color:white" v-bind:class="[st==true ? 'bg-success' : 'bg-danger']" >
                  <div v-if="st==true" @click="setForStudent(false, topics[stindex], student, index, stindex)">ирсэн</div>
                  <div v-else @click="setForStudent(true, topics[stindex], student, index, stindex)">ирээгүй</div>
                </td>
              
              </tr>
              
            </tbody>
          </table>
          <div v-else class="alert alert-warning">
            <h5>Одоогоор сурагч байхгүй байна.</h5>
          </div>
        </div>
      </div>
    </div>


    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "LessonDetail",
    data() {
        return {
            lesson: null,
            topics:[],
            students:[]
            
        };
    },
    methods: {
        
      _getQA(){


          fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
              let lesson=doc.data()
              lesson.id=doc.id
              this.lesson=lesson;
            
          });

          

          fb.db.collection("lessons").doc(this.lessonId).collection("topics").orderBy("createdAt","asc").get().then(querySnapshot=> {
            this.topics=[]
            querySnapshot.forEach(doc=> {
              let object=doc.data()
              object.id = doc.id;
            
					    this.topics.push(object);
            });

            fb.db.collection("lessons/"+this.lessonId+'/studentList').onSnapshot(querySnapshot=> {
              this.students=[]
              querySnapshot.forEach(stddata=> {
                let object=stddata.data()
                object.id = stddata.id;
                object.student=null;
                object.ref=stddata.ref;
                object.attendances=[];
                if(stddata.data().studentRef!=null){
                  stddata.data().studentRef.get().then(studentDoc=>{
                    object.student=studentDoc.data();
                  });
                }
                for(var topic of this.topics){
                  this.getAttendanceForStudent(topic, object, stddata.ref);
                  
                }
                this.students.push(object);
              });

              fb.db.collection("lessons").doc(this.lessonId).update({"numberOfStudents": querySnapshot.size});

            });
            
          });

      },

      setForStudent(value, topic, student, stindex, index){
        this.setProperty("status", fb.db.doc("lessons/"+this.lessonId+'/studentList/'+student.id+"/attendance/"+topic.id), value);
        this.$set(this.students[stindex]['attendances'], index, value);
        if(value==true){
          fb.db.doc("lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfArrived": fb.firestore.FieldValue.increment(1)});
        }
        else  
          fb.db.doc("lessons/"+this.lessonId+'/topics/'+topic.id).update({"numberOfArrived": fb.firestore.FieldValue.increment(-1)});
     
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.set(tmp);
        }
      },
      async getAttendanceForStudent(topic, student, studentRef){
        var stAd=await studentRef.collection("attendance").doc(topic.id).get()
        if(stAd.exists && stAd.data().status==true)
          student.attendances.push(true);
        else{
          student.attendances.push(false);
        }
                
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

